import { render } from "./AssassinateHistory.vue?vue&type=template&id=f966f558&scoped=true"
import script from "./AssassinateHistory.vue?vue&type=script&lang=js"
export * from "./AssassinateHistory.vue?vue&type=script&lang=js"

import "./AssassinateHistory.vue?vue&type=style&index=0&id=f966f558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f966f558"]])

export default __exports__